module.exports = __webpack_public_path__ + "app-static/img/part3.73e7f631.png";